import React from 'react';
import clsx from 'clsx';
import { Icon } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAuthenticationStore } from 'Hooks/zustand/useAuthenticationStore';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getUser } from 'Selectors';
import { useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';

import styles from './ImpersonateHeader.css';

function ImpersonationHeader() {
    const { t } = useTranslation();
    const { stopImpersonation } = useAuthenticationStore();
    const { clearTemplate } = useTemplateStore();
    const { landlordId, tenantKey } = useSelector(getUser);
    const history = useHistory();
    const queryClient = useQueryClient();

    const backToLandlordView = async () => {
        clearTemplate();
        await stopImpersonation(landlordId!);
        await queryClient.invalidateQueries();
        const search = new URLSearchParams({ flow: 'tenants' }).toString();
        history.replace({ pathname: '/', search });
    };

    return (
        <div className={styles.impersonateHeaderContainer}>
            <div className={styles.impersonateHeaderItem}>
                {t('LoggedInAs', { tenantKey: tenantKey.toUpperCase(), landlordId: landlordId?.toUpperCase() })}
            </div>
            <div
                className={clsx(styles.impersonateHeaderItem, styles.backButtonWrapper)}
                onClick={backToLandlordView}
                onKeyDown={backToLandlordView}
                role='button'
                tabIndex={0}
            >
                <Icon name='arrow-left-1' size='sm' className={styles.backIcon} />
                <span>{t('BackToRulesManagement')}</span>
            </div>
        </div>
    );
}

export default ImpersonationHeader;
